import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";
import StatusBadge from "./StatusBadge";

const DetailModal = ({ isOpen, organization, onClose, onApprove, onReject, onSuspend, onReactivate }) => {
  if (!isOpen || !organization) return null;

  const fields = [
    { label: "NIT", value: organization?.nit, icon: "Hash" },
    { label: "Razón Social", value: organization?.businessName, icon: "Building2" },
    { label: "Correo Electrónico", value: organization?.email, icon: "Mail" },
    { label: "Teléfono", value: organization?.phone || "No registrado", icon: "Phone" },
    { label: "Ciudad", value: organization?.city || "No registrada", icon: "MapPin" },
    { label: "Dirección", value: organization?.address || "No registrada", icon: "Navigation" },
    { label: "Fecha de Registro", value: organization?.registrationDate, icon: "Calendar" },
    { label: "Contacto Principal", value: organization?.contactName || "No registrado", icon: "User" },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div
        className="w-full max-w-xl rounded-2xl shadow-xl overflow-hidden max-h-[90vh] flex flex-col"
        style={{ backgroundColor: "var(--color-card)" }}
        role="dialog"
        aria-modal="true"
      >
        {/* Header */}
        <div className="px-6 py-4 flex items-center justify-between border-b" style={{ borderColor: "var(--color-border)", backgroundColor: "var(--color-muted)" }}>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: "var(--color-primary)" }}>
              <Icon name="Building2" size={20} color="white" />
            </div>
            <div>
              <h2 className="font-heading font-bold text-base" style={{ color: "var(--color-foreground)" }}>
                Detalle de Organización
              </h2>
              <StatusBadge status={organization?.status} />
            </div>
          </div>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-200 transition-colors">
            <Icon name="X" size={18} color="var(--color-muted-foreground)" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 overflow-y-auto flex-1">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {fields?.map((field) => (
              <div key={field?.label} className="flex items-start gap-3 p-3 rounded-lg border" style={{ borderColor: "var(--color-border)", backgroundColor: "var(--color-background)" }}>
                <Icon name={field?.icon} size={16} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
                <div className="min-w-0">
                  <p className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>{field?.label}</p>
                  <p className="text-sm font-caption font-medium mt-0.5 break-words" style={{ color: "var(--color-foreground)" }}>{field?.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer Actions */}
        <div className="px-6 py-4 border-t flex flex-wrap gap-2 justify-end" style={{ borderColor: "var(--color-border)" }}>
          <Button variant="outline" onClick={onClose}>Cerrar</Button>
          {organization?.status === "PENDING" && (
            <>
              <Button variant="success" iconName="UserCheck" iconPosition="left" onClick={() => { onApprove(organization); onClose(); }}>Aprobar</Button>
              <Button variant="destructive" iconName="UserX" iconPosition="left" onClick={() => { onReject(organization); onClose(); }}>Rechazar</Button>
            </>
          )}
          {organization?.status === "ACTIVE" && (
            <Button variant="warning" iconName="PauseCircle" iconPosition="left" onClick={() => { onSuspend(organization); onClose(); }}>Suspender</Button>
          )}
          {organization?.status === "SUSPENDED" && (
            <Button variant="default" iconName="PlayCircle" iconPosition="left" onClick={() => { onReactivate(organization); onClose(); }}>Reactivar</Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailModal;